import { pipe } from 'valibot';

import { emailWrapper, stringRequired } from './schema.utils';

export const EmailSchema = () => pipe(stringRequired(), emailWrapper());
